import { useEffect, useState, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from './AuthContext';

export interface PublicRouteGateProps {
  children: ReactNode;
  authenticatedRedirect: string;
  redirectOnlyFrom: string;
}

/** Routing-only gate; public product pages remain one sealed visual archetype. */
export function PublicRouteGate({
  children,
  authenticatedRedirect,
  redirectOnlyFrom,
}: PublicRouteGateProps) {
  const { isAuthenticated, isLoading } = useAuthContext();
  const location = useLocation();
  const [coldBootstrapSettled, setColdBootstrapSettled] = useState(!isLoading);
  const pendingAuthRoute = (location.state as { pendingAuthRoute?: unknown } | null)
    ?.pendingAuthRoute;
  useEffect(() => {
    if (!isLoading) setColdBootstrapSettled(true);
  }, [isLoading]);
  if (!coldBootstrapSettled) return null;
  if (
    isAuthenticated
    && location.pathname === redirectOnlyFrom
    && typeof pendingAuthRoute !== 'string'
  ) {
    return <Navigate to={authenticatedRedirect} replace />;
  }
  return children;
}
